import axios from "axios";

// const API_BASE_URL = "http://localhost:5000/api";
const API_BASE_URL = "https://blogs-api.oyecreators.com/api";

// 🛠️ Create Axios instances
const createAxiosInstance = (baseURL) =>
  axios.create({
    baseURL,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });

const axiosInstance = createAxiosInstance(API_BASE_URL);
const refreshAxios = createAxiosInstance(API_BASE_URL);

// 🎯 Attach Authorization token before every request
axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// 🚀 Handle API responses and errors globally
axiosInstance.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    if (!error.response)
      return Promise.reject(new Error("Network error, please try again."));

    const { status, config } = error.response;

    if (status === 401 || status === 403) {
      try {
        const refreshResponse = await refreshAxios.post("/auth/refresh");
        const newAccessToken = refreshResponse.data.accessToken;
        console.log("newAccessToken", newAccessToken);
        if (newAccessToken) {
          localStorage.setItem("accessToken", newAccessToken);
          config.headers.Authorization = `Bearer ${newAccessToken}`;
          return axiosInstance(config);
        }
      } catch {
        localStorage.removeItem("accessToken");
        window.location.href = "/admin";
        return Promise.reject(
          new Error("Session expired. Please log in again.")
        );
      }
    }

    return Promise.reject(
      new Error(error.response.data?.message || "An error occurred.")
    );
  }
);

export const api = {
  auth: {
    register: async (userData) => {
      const response = await axiosInstance.post("/auth/register", userData);
      localStorage.setItem("accessToken", response.accessToken);
      return response;
    },
    login: async (credentials) => {
      const response = await axiosInstance.post("/auth/login", credentials);
      localStorage.setItem("accessToken", response.accessToken);
      return response;
    },
    me: () => axiosInstance.get("/auth/me"),
    logout: () => {
      localStorage.removeItem("accessToken");
      window.location.href = "/admin";
    },
  },
  posts: {
    getAll: (params) => axiosInstance.get("/posts", { params }),
    getById: (id) => axiosInstance.get(`/posts/${id}`),
    getBySlug: (slug) => axiosInstance.get(`/posts/slug/${slug}`),
    create: (postData) => axiosInstance.post("/posts", postData),
    update: (id, postData) => axiosInstance.put(`/posts/${id}`, postData),
    delete: (id) => axiosInstance.delete(`/posts/${id}`),
  },
  categories: {
    getAll: () => axiosInstance.get("/categories"),
    create: (categoryData) => axiosInstance.post("/categories", categoryData),
    update: (id, categoryData) =>
      axiosInstance.put(`/categories/${id}`, categoryData),
    delete: (id) => axiosInstance.delete(`/categories/${id}`),
  },
  media: {
    upload: (formData) =>
      axiosInstance.post("/media", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      }),
    delete: (id) => axiosInstance.delete(`/media/${id}`),
  },
  analytics: {
    trackPageView: (data) => axiosInstance.post("/analytics/pageview", data),

    trackEvent: (data) => axiosInstance.post("/analytics/event", data),

    getDashboardData: () => axiosInstance.get("/analytics/dashboard-data"),

    getSEOData: () => axiosInstance.get("/analytics/seo-data"),
  },
};
